import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=6fd40d7f"
import script from "./BaseListItem.vue?vue&type=script&lang=js"
export * from "./BaseListItem.vue?vue&type=script&lang=js"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=6fd40d7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports